import React, { useState, useEffect } from 'react';
import { useTypedSelector } from '../../types/global';
import applicationListSelectors from '../../modules/application/list/applicationListSelectors';
import { selectEnvironment } from '../../modules/global';
import { isKSACountry } from '../../config/countriesEnvironments';
import { addressVerificationStorage } from './addressVerificationStorage';
import { accountVerificationStorage } from '../../view/AccountVerificationPage/accountVerificationStorage';
import ProTipToast from '../../view/AccountVerificationPage/ProTipToast';

function AddressVerificationProTipWrapper() {
  const environment = useTypedSelector(selectEnvironment);
  const application = useTypedSelector(
    applicationListSelectors.selectApplication,
  );

  const shouldShowForCountry = !isKSACountry;

  const arePromotionBannersDismissed = () => {
    if (!application?.id) return false;

    const isAvsPromotionDismissed =
      accountVerificationStorage.shouldShowBanner(
        environment,
        application.id,
      ) === false;
    const isAddressVerificationPromotionDismissed =
      addressVerificationStorage.shouldShowBanner(
        environment,
        application.id,
      ) === false;

    return isAvsPromotionDismissed && isAddressVerificationPromotionDismissed;
  };

  const [isProTipVisible, setIsProTipVisible] = useState(
    () =>
      shouldShowForCountry &&
      application?.id &&
      !addressVerificationStorage.isProTipDismissed(
        environment,
        application.id,
      ) &&
      arePromotionBannersDismissed(),
  );

  useEffect(() => {
    if (!application?.id) return;

    const isAvsPromotionDismissed =
      accountVerificationStorage.shouldShowBanner(
        environment,
        application.id,
      ) === false;
    const isAddressVerificationPromotionDismissed =
      addressVerificationStorage.shouldShowBanner(
        environment,
        application.id,
      ) === false;
    const areAllPromotionBannersDismissed =
      isAvsPromotionDismissed && isAddressVerificationPromotionDismissed;

    if (
      shouldShowForCountry &&
      !isProTipVisible &&
      !addressVerificationStorage.isProTipDismissed(
        environment,
        application.id,
      ) &&
      areAllPromotionBannersDismissed
    ) {
      setIsProTipVisible(true);
    }
  }, [isProTipVisible, environment, application?.id, shouldShowForCountry]);

  const handleProTipDismiss = () => {
    if (application?.id) {
      addressVerificationStorage.setProTipDismissed(
        environment,
        application.id,
      );
      setIsProTipVisible(false);
    }
  };

  const handleProTipClick = () => {
    if (application?.id) {
      window.open(
        'https://docs.leantech.me/docs/how-to-use-address-verification',
        '_blank',
      );
    }
  };

  if (!isProTipVisible || !shouldShowForCountry) {
    return null;
  }

  return (
    <div
      style={{ position: 'fixed', bottom: '24px', left: '24px', zIndex: 1000 }}
    >
      <ProTipToast
        onDismiss={handleProTipDismiss}
        onClick={handleProTipClick}
        label="NEW"
        message="Try address verification"
      />
    </div>
  );
}

export default AddressVerificationProTipWrapper;
